export default "__VITE_ASSET__$1eaZgdT__"